import React, { useState } from "react";
import { MdVisibility, MdVisibilityOff } from "react-icons/md";

export default function PasswordField({
  label,
  name,
  value,
  onChange,
  onBlur,
  placeholder,
  disabled = false,
  autoComplete = "new-password",
  invalid = false,
  invalidText,
  withToggle = true,
}) {
  const [show, setShow] = useState(false);

  const inputId = name || `password-${label?.toLowerCase().replace(/\s+/g, "-")}`;
  const feedbackId = invalid ? `${inputId}-feedback` : undefined;
  const type = withToggle && show ? "text" : "password";

  const input = (
    <input
      id={inputId}
      name={name}
      type={type}
      className={`form-control ${invalid ? "is-invalid" : ""}`}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      placeholder={placeholder}
      autoComplete={autoComplete}
      disabled={disabled}
      aria-invalid={invalid || undefined}
      aria-describedby={feedbackId}
    />
  );

  return (
    <div className="mb-3">
      {label && (
        <label className="form-label" htmlFor={inputId}>
          {label}
        </label>
      )}

      {withToggle ? (
        <div className="input-group">
          {input}
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={() => setShow((prev) => !prev)}
            tabIndex={-1}
            disabled={disabled}
            aria-label={show ? "Hide password" : "Show password"}
          >
            {show ? <MdVisibilityOff /> : <MdVisibility />}
          </button>
        </div>
      ) : (
        input
      )}

      {invalid && invalidText && (
        <div id={feedbackId} className="invalid-feedback d-block">
          {invalidText}
        </div>
      )}
    </div>
  );
}
